import { render } from "./UsersListTable.vue?vue&type=template&id=1b2d1544"
import script from "./UsersListTable.vue?vue&type=script&lang=js"
export * from "./UsersListTable.vue?vue&type=script&lang=js"

import exportComponent from "/codebuild/output/src973090976/src/remoterespects-admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__